export const LogoFields = [
    { identifier: 'logo-size', type: 'input', field: 'logo-size' }
]
